import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.358 19.357a8 8 0 0 0 8.465 1.834l.269-.1a2 2 0 0 0 .712-3.287l-1.39-1.39a2 2 0 0 0-2.828 0l-.672.672a2 2 0 0 1-2.828 0l-2.172-2.172a2 2 0 0 1 0-2.828l.672-.672a2 2 0 0 0 0-2.828l-1.39-1.39a2 2 0 0 0-3.286.712l-.101.269a8 8 0 0 0 1.834 8.465zm5.377-10.809 2.436-4.81c.475-.94 1.892-.601 1.892.451V8h2.32a1 1 0 0 1 .894 1.448l-2.415 4.83c-.47.94-1.886.61-1.894-.44L15.938 10h-2.31a1 1 0 0 1-.893-1.452"
    }
  )
);
var SvgFollowUpFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FollowUpFilled_default = SvgFollowUpFilled;

export { FollowUpFilled_default as default };
